import { useContext } from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  BrowserRouter as Router,
  HashRouter,
  Route,
  Routes,
} from "react-router-dom";

import { userInputs } from "./formSource";
import { DarkModeContext } from "./context/darkModeContext";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import List from "./pages/list/List";

// campaign related route
import InitialApproveCamp from "./pages/Campaign/InitialApprovedCampaign/index";
import CampaignView from "./pages/Campaign/InitialApprovedCampaign/View/Campaignview";
import CampaignEdit from "./pages/Campaign/InitialApprovedCampaign/Edit/CampaignEdit";
import ActiveCampView from "./pages/Campaign/ActiveCampaign/View/ActiveCmapaignView";
import ActiveCampaign from "./pages/Campaign/ActiveCampaign/index";
import CompletedCamp from "./pages/Campaign/CompletedCampaign/index";
import CompletedCampView from "./pages/Campaign/CompletedCampaign/View/CompletedCamp";
import PausedCamp from "./pages/Campaign/PausedCampaign/index";
import PausedCampaignView from "./pages/Campaign/PausedCampaign/View/PausedCamp";
import ClosedCamp from "./pages/Campaign/ClosedCampaign/index";
import ClosedCampaignView from "./pages/Campaign/ClosedCampaign/View/ClosedCamp";
import ComingSoonCamp from "./pages/Campaign/ComingSoonCampaign/index";
import ComingSoonCampaignView from "./pages/Campaign/ComingSoonCampaign/View/ComingSoonCamp";
import DeletedCamp from "./pages/Campaign/DeletedCampaign/index";
import DeletedCampView from "./pages/Campaign/DeletedCampaign/View/DeletedCampView";
import RejectedCamp from "./pages/Campaign/RejectedCampaign/index";
import RejectedCampaignView from "./pages/Campaign/RejectedCampaign/View/RejectedCampaignView";
import ReviewCamp from "./pages/Campaign/For Review/index";
import Reviewcampaign from "./pages/Campaign/For Review/View/Reviewcampaign";
import CreateCampaignPage from "./pages/Campaign/CreateCampaign/index";
import Inventmelist from "./pages/InventMe/index";
import InventmeView from "./pages/InventMe/View/ArticleView";
// user related route
import RegisterUsersList from "./pages/Roles-permission/Roles/index";
import New from "./pages/new/New";
import UserEdit from "./pages/Roles-permission/Roles/Edit/Rolesedit";
import UserDetailsView from "./pages/Roles-permission/Roles/View/UsersDetails";
import Permission from "./components/notfound/Permssion";
import PermissionRoute from "./auth/PermissionRoute";
import { ADMIN, SUPERADMIN } from "./components/constant/constant";
import UserList from "./pages/users/index";
import UserPermission from "./pages/users/edit/ManagePermission";
//accredited-investers-components
import AccreditedList from "./pages/accreditedInvestors/index";
import UserView from "./pages/users/view/Viewuser";
import ViewAccreditedInvestors from "./pages/accreditedInvestors/viewAccreditedInvestors/viewAccreditedInvestors";

//currency-management-components
import CurrenciesList from "./pages/currencyManagement/index";

// public pages route
import Abouts from "./pages/Others/Aboutus/index";
import AddContent from "./pages/Others/Aboutus/Add/AddNew";
import Contentview from "./pages/Others/Aboutus/View/Viewcontent";
import Contentedit from "./pages/Others/Aboutus/edit/Contentedit";
import AddCategory from "./pages/Others/Category/Add/Addcategory";
import CategoryList from "./pages/Others/Category/index";
import Categoryview from "./pages/Others/Category/View/Categoryview";
import CategoryEdit from "./pages/Others/Category/Edit/Editcategory";
import AddTeams from "./pages/Others/OurTeams/Add/Addteam";
import TeamList from "./pages/Others/OurTeams/index";
import Teamview from "./pages/Others/OurTeams/View/Viewteam";
import Teamedit from "./pages/Others/OurTeams/Edit/Editteam";
import Addfeature from "./pages/Others/Feature/Add/Addfeature";
import Featurelist from "./pages/Others/Feature/index";
import FeatureView from "./pages/Others/Feature/View/Viewfeature";
import FeatureEdit from "./pages/Others/Feature/Edit/Editfeature";
import AddPartner from "./pages/Others/Our Partners/Add/PartnerAdd";
import PartnerList from "./pages/Others/Our Partners/index";
import PartnerView from "./pages/Others/Our Partners/View/PartnerView";
import Partneredit from "./pages/Others/Our Partners/Edit/PartnerEdit";
import StroyList from "./pages/Others/SuccessStory/index";
import AddStory from "./pages/Others/SuccessStory/Add/Addstory";
import StoryView from "./pages/Others/SuccessStory/View/Viewstory";
import Storyedit from "./pages/Others/SuccessStory/Edit/Editstory";
import AdvisoryList from "./pages/Others/Our Advisory/inex";
import Addadvisory from "./pages/Others/Our Advisory/Add/Addadvisory";
import AdvisoryView from "./pages/Others/Our Advisory/View/Viewadvisory";
import Advisoryedit from "./pages/Others/Our Advisory/Edit/Editadvisory";
// investment & transaction route
import InvestmentList from "./pages/Investment/index";
import InvestmentView from "./pages/Investment/view/InvestmentView";
import InvestmentEdit from "./pages/Investment/edit/InvestmentEdit";
import TransactionList from "./pages/Transaction/index";
import TransactionView from "./pages/Transaction/view/TransactionView";
import SuitabilityList from "./pages/suitability test/index";
import SuitabilityView from "./pages/suitability test/view/SuitabilityView";

// offeror faq
import OfferorList from "./pages/Faq/Offeror/index";
import OfferorFaqAdd from "./pages/Faq/Offeror/Add/AddOfferorFaq";
import OfferorFaqEdit from "./pages/Faq/Offeror/Edit/OfferorFaqEdit";
import OfferorFaqView from "./pages/Faq/Offeror/View/OfferorFaqView";
// accredited faq
import AccreditedFaqList from "./pages/Faq/Accredited/index";
import AccreditedFaqAdd from "./pages/Faq/Accredited/Add/AddAccreditedInvestorFaq";
import AccreditedFaqEdit from "./pages/Faq/Accredited/Edit/AccreditedFaqEdit";
import AccreditedFaqView from "./pages/Faq/Accredited/View/AccreditedFaqView";

// investor faq
import InvestorFaqList from "./pages/Faq/Investor/index";
import AddInvestorFaq from "./pages/Faq/Investor/Add/AddInvestorFaq";
import InvestorFaqEdit from "./pages/Faq/Investor/Edit/InvestorFaqEdit";
import InvestorFaqView from "./pages/Faq/Investor/View/InvestorFaqView";
// job related route
import JobList from "./pages/Others/CarrerUs/index";
import Addjob from "./pages/Others/CarrerUs/Add/Addjob";
import Jobview from "./pages/Others/CarrerUs/View/CareerView";
import Jobedit from "./pages/Others/CarrerUs/Edit/Jobedit";
import ApplicationListing from "./pages/Others/Job Applications/index";
// other route
import SocialList from "./pages/Others/Social Links/index";
import SocialView from "./pages/Others/Social Links/View/Socialview";
import SocialEdit from "./pages/Others/Social Links/Edit/Socialedit";
import LangaugeList from "./pages/Others/Language/index";
import Addlanguage from "./pages/Others/Language/Add/Addlanguage";
import LanguageView from "./pages/Others/Language/View/Viewlanguage";
import LanguageEdit from "./pages/Others/Language/Edit/LanguageEdit";
import ContactList from "./pages/Others/ContactUs/index";
import ContactView from "./pages/Others/ContactUs/View/Viewcontactus";
import ContactPartnerList from "./pages/Others/Conatct Partner/index";
import ContactPartneView from "./pages/Others/Conatct Partner/View/Viewcontactus";
import Forgot from "./pages/Forgot/Forgot";
import Reset from "./pages/ResetPassword/Reset";
import Report from "./pages/Advisor/index";
import ViewInvestmentUser from "./pages/Advisor/viewReport/ViewInvestmentReport";
import ManageRole from "./pages/users/ManageRole";
import ManagePermissions from "./pages/users/edit/ManagePermission";
import ManageDesignation from "./pages/users/ManageDesignation";
import ManageDesignationReport from "./pages/users/ManageDesignationReport";
import DesignationReportDetails from "./pages/users/DesignationReportDetails";
import Commission from "./pages/users/Commission";
import JwtAuth from "./components/JwtAuth/JwtAuth";
import ProtectedRoutes from "./auth/ProtectedRoutes";
import PublicRoutes from "./auth/PublicRoutes";
import PrivateRoutes from "./auth/PrivateRoutes";
import NotFound from "./components/notfound/NotFound";
import NewsView from "./pages/News/View/NewsView";
import News from "./pages/News";
import NewsAddEdit from "./pages/News/AddEdit/NewsAddEdit";
import { PermissionsProvider } from "./context/permissionContext";
import "./style/dark.scss";

function App() {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <HashRouter>
        <PermissionsProvider>
          <JwtAuth />

          <Routes>
            <Route element={<PublicRoutes />}>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<Forgot />} />
            </Route>

            {/* All private/protected routes */}
            <Route element={<PrivateRoutes />}>
              <Route path="/" element={<Home />} />

              <Route
                path="create-campaign"
                element={
                  <ProtectedRoutes requiredPath="Campaign - Create:Edit">
                    <CreateCampaignPage />
                  </ProtectedRoutes>
                }
              />

              <Route path="initial-approve">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Initial Approval:View">
                      <CampaignView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit/:campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Initial Approval:Edit">
                      <CampaignEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Initial Approval:View">
                      <InitialApproveCamp />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="active-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Active:View">
                      <ActiveCampView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Active:View">
                      <ActiveCampaign />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="rejected-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Rejected:View">
                      <RejectedCampaignView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Rejected:View">
                      <RejectedCamp />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route path="completed-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Completed:View">
                      <CompletedCampView />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Completed:View">
                      <CompletedCamp />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="paused-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Paused campaigns:View">
                      <PausedCampaignView />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Paused campaigns:View">
                      <PausedCamp />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="closed-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Closed Campaigns:View">
                      <ClosedCampaignView />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Closed Campaigns:View">
                      <ClosedCamp />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route path="coming-soon-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Upcoming Campaigns:View">
                      <ComingSoonCampaignView />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Upcoming Campaigns:View">
                      <ComingSoonCamp />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route path="deleted-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Deleted:View">
                      <DeletedCampView />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Deleted:View">
                      <DeletedCamp />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route path="for-review-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - For Review:View">
                      <Reviewcampaign />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - For Review:View">
                      <ReviewCamp />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route exact path="pages">
                <Route
                  path="add-content"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Page List:Edit">
                      <AddContent />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":pageId"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Page List:View">
                      <Contentview />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit/:pageId"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Page List:Edit">
                      <Contentedit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Pages - Page List:View">
                      <Abouts />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="categories">
                <Route
                  path="add-category"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Categories:Edit">
                      <AddCategory />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":categoryId"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Categories:View">
                      <Categoryview />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit/:categoryId"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Categories:Edit">
                      <CategoryEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Pages - Categories:View">
                      <CategoryList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="our-teams">
                <Route
                  path="add-teams"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Our Team:Edit">
                      <AddTeams />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":teamId"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Our Team:View">
                      <Teamview />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit/:teamId"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Our Team:View">
                      <Teamedit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Pages - Our Team:View">
                      <TeamList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="features">
                <Route
                  path="add-feature"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Feature:Edit">
                      <Addfeature />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":featureId"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Feature:View">
                      <FeatureView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit/:featureId"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Feature:Edit">
                      <FeatureEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Pages - Feature:View">
                      <Featurelist />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="our-partners">
                <Route
                  path="add-partner"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Advisory Board:Edit">
                      <AddPartner />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":partnerId"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Advisory Board:View">
                      <PartnerView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit/:partnerId"
                  element={
                    <ProtectedRoutes requiredPath="Pages - Advisory Board:Edit">
                      <Partneredit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Pages - Advisory Board:View">
                      <PartnerList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="success-story">
                <Route path="add-story" element={<AddStory />} />
                <Route path=":storyId" element={<StoryView />} />
                <Route path="edit/:storyId" element={<Storyedit />} />
                <Route index element={<StroyList />} />
              </Route>
              <Route exact path="advisory-board">
                <Route path="add-advisory" element={<Addadvisory />} />
                <Route path=":advosoryId" element={<AdvisoryView />} />
                <Route path="edit/:advosoryId" element={<Advisoryedit />} />
                <Route index element={<AdvisoryList />} />
              </Route>
              <Route exact path="social-media-links">
                {/* <Route path="add-links" element={<Addadvisory />} /> */}
                <Route path=":socialId" element={<SocialView />} />
                <Route path="edit/:socialId" element={<SocialEdit />} />
                <Route index element={<SocialList />} />
              </Route>
              <Route exact path="language">
                <Route path="add-language" element={<Addlanguage />} />
                <Route path=":langId" element={<LanguageView />} />
                <Route path="edit/:langId" element={<LanguageEdit />} />
                <Route index element={<LangaugeList />} />
              </Route>
              <Route exact path="contact-us">
                <Route
                  path=":contactId"
                  element={
                    <ProtectedRoutes requiredPath={"Pages - Contact Us:View"}>
                      <ContactView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath={"Pages - Contact Us:View"}>
                      <ContactList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="contact-us-partner">
                <Route
                  path=":contactId"
                  element={
                    <ProtectedRoutes
                      requiredPath={"Pages - Contact Us (Partner):View"}
                    >
                      <ContactPartneView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes
                      requiredPath={"Pages - Contact Us (Partner):View"}
                    >
                      <ContactPartnerList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="users">
                <Route
                  path=":userId"
                  element={
                    <ProtectedRoutes requiredPath="Users Management - Users:View">
                      <UserView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Users Management - Users:View">
                      <UserList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="inventme">
                <Route
                  path=":articleId"
                  element={
                    <ProtectedRoutes requiredPath="InventMe Management:View">
                      <InventmeView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="InventMe Management:View">
                      <Inventmelist />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="news">
                <Route
                  path="add-news"
                  element={
                    <ProtectedRoutes requiredPath="News:Edit">
                      <NewsAddEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit-news/:newsId"
                  element={
                    <ProtectedRoutes requiredPath="News:Edit">
                      <NewsAddEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":newsId"
                  element={
                    <ProtectedRoutes requiredPath="News:View">
                      <NewsView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="News:View">
                      <News />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="accredited-investors">
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Accredited Investors:View">
                      <AccreditedList />
                    </ProtectedRoutes>
                  }
                />
                {/* <Route path=":userId" element={<ViewAccreditedInvestors />} /> */}
              </Route>
              <Route exact path="currency-management">
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Currency Management:View">
                      <CurrenciesList />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route exact path="career">
                <Route
                  path="add-job"
                  element={
                    <ProtectedRoutes requiredPath="Jobs Management:Edit">
                      <Addjob />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":jobId"
                  element={
                    <ProtectedRoutes requiredPath="Jobs Management:View">
                      <Jobview />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit/:jobId"
                  element={
                    <ProtectedRoutes requiredPath="Jobs Management:Edit">
                      <Jobedit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Jobs Management:View">
                      <JobList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="jobs">
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Jobs Management - Job Applications:View">
                      <ApplicationListing />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="investment">
                <Route
                  path=":investmentId"
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Investment:View">
                      <InvestmentView />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  path="edit/:investmentId/:campaignId"
                  element={<InvestmentEdit />}
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Investment:View">
                      <InvestmentList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="suitability-overview">
                <Route
                  path=":suitabilityId"
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Suitability Overview:View">
                      <SuitabilityView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Suitability Overview:View">
                      <SuitabilityList />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route exact path="transaction">
                <Route
                  path=":transactionId"
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Transaction:View">
                      <TransactionView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Transaction:View">
                      <TransactionList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="accredited-faq">
                <Route
                  path="add"
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Accredited:Edit">
                      <AccreditedFaqAdd />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":accreditedFaqId"
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Accredited:View">
                      <AccreditedFaqView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit/:accreditedFaqId"
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Accredited:Edit">
                      <AccreditedFaqEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Accredited:View">
                      <AccreditedFaqList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="offeror-faq">
                <Route
                  path="add"
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Offeror:Edit">
                      <OfferorFaqAdd />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":offerorId"
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Offeror:View">
                      <OfferorFaqView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit/:offerorId"
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Offeror:Edit">
                      <OfferorFaqEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Offeror:View">
                      <OfferorList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="investor-faq">
                <Route
                  path="add"
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Investor:Edit">
                      <AddInvestorFaq />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":faqId"
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Investor:View">
                      <InvestorFaqView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit/:faqId"
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Investor:Edit">
                      <InvestorFaqEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="FAQ's - Investor:View">
                      <InvestorFaqList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="/permission" element={<Permission />} />
              <Route path="/profile" element={<New inputs={userInputs} />} />

              <Route exact path="report">
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Advisor - Investment Report:View">
                      <Report />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":reportId"
                  element={
                    <ProtectedRoutes requiredPath="Advisor - Investment Report:View">
                      <ViewInvestmentUser />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/manage-role"
                element={
                  <ProtectedRoutes requiredPath="Users Management - Manage System Role:View">
                    <ManageRole />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/manage-designation"
                element={
                  <ProtectedRoutes requiredPath="Users Management - Manage Designations:View">
                    <ManageDesignation />
                  </ProtectedRoutes>
                }
              />
              <Route exact path="designation-report">
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Users Management - Designation Report:View">
                      <ManageDesignationReport />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  path=":managerId"
                  element={
                    <ProtectedRoutes requiredPath="Users Management - Designation Report:View">
                      <DesignationReportDetails />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/manage-permissions"
                element={
                  <ProtectedRoutes requiredPath="Users Management - Manage Permissions:View">
                    <ManagePermissions />
                  </ProtectedRoutes>
                }
              />

              <Route
                path="/commission"
                element={
                  <ProtectedRoutes requiredPath="Users Management - Manage Commissions:View">
                    <Commission />
                  </ProtectedRoutes>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Route>
            {/* </Route> */}
          </Routes>
        </PermissionsProvider>
      </HashRouter>
    </div>
  );
}

export default App;
